module.exports = __webpack_public_path__ + "img/logo-ct.e5583465.png";